import { Component } from '@angular/core';

@Component({
  selector: 'app-loading-progress-modal',
  templateUrl: './loading-progress-modal.component.html',
  styleUrls: ['./loading-progress-modal.component.scss']
})
export class LoadingProgressModalComponent {

}
